
/// <amd-module name="CodeCoverage/CodeCoverageProvider/CodeCoveragePRAdornments" />

import * as Resources from "CodeCoverage/CodeCoverageProvider/Resources";
import * as React from 'react';
import { ITestResultsRestClient } from "Test/Client/RestClient/TestResults"
import { CoverageStatus, FileCoverage, FileCoverageRequest } from 'Test/common-util/Contracts/Test';
import { IGutterAdornmentBlock, IGutterAdornmentCollection, IndicatorType } from 'VC/Pullrequest/Common/GutterAdornments';
import { IPullRequestAdornmentService, IPullRequestContext, IPullRequestFileContext } from 'VC/Pullrequest/Common/PullRequestAdornmentService';
import { IVssPageContext, Services, VssService } from 'VSS/Platform/Context';
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";

export class CodeCoveragePrAdornmentService extends VssService implements IPullRequestAdornmentService {

    private _pullRequestContext: IPullRequestContext;
    private _client: ITestResultsRestClient
    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);

        const queryTcmDirectly = "WebAccess.TestManagement.QueryFromTcmService";
        if (isFeatureFlagEnabled(pageContext, queryTcmDirectly, false)) {
            this._client = pageContext.getRestClient<ITestResultsRestClient>("ITestResultsRestClient");
        }
    }

    public getGutterAdornments(pullRequestFileContext: IPullRequestFileContext): Promise<IGutterAdornmentCollection> {
        return new Promise((resolve, reject) => {
            this.getFileCoverage(pullRequestFileContext).then((fileCoverageData: string) => {
                this.mapGutterAdornments(fileCoverageData, pullRequestFileContext.oPath ? false : true).then((gutterAdornmentCollection) => {
                    resolve(gutterAdornmentCollection);
                }).catch((reason) => {
                    console.error(reason);
                    reject(reason);
                });
            }
            ).catch((reason) => {
                console.error(reason);
                reject(reason);
            }
            );
        });
    }

    public getExtensionName(): Promise<string> {
        return Promise.resolve("CodeCoverage");
    }

    public initializeExtension(pullRequestContext: IPullRequestContext): void {
        this._pullRequestContext = pullRequestContext;
    }

    private getFileCoverage(pullRequestFileContext: IPullRequestFileContext): Promise<string | null> {
        if (this._client) {
            const fileCoverageRequest: FileCoverageRequest = {
                filePath: pullRequestFileContext.mPath ? pullRequestFileContext.mPath : pullRequestFileContext.oPath, // Choose between mPath or oPath depending on if this is a new file
                pullRequestBaseIterationId: pullRequestFileContext.baseIterationId,
                pullRequestId: this._pullRequestContext.pullRequestId,
                pullRequestIterationId: pullRequestFileContext.iterationId,
                repoId: this._pullRequestContext.repositoryId
            };
            return this._client.getFileLevelCodeCoverage(fileCoverageRequest, this._pullRequestContext.projectId);
        }

        return Promise.resolve(null);
    }

    private mapGutterAdornments(fileCoverageDataText: string, isNewFile: Boolean): Promise<IGutterAdornmentCollection> {
        const gutterAdornmentCollection: IGutterAdornmentCollection = {
            modifiedFilegutterAdornments: [],
            originalFilegutterAdornments: []
        };

		if(!fileCoverageDataText){
			return Promise.resolve(gutterAdornmentCollection);
		}

		const fileCoverageData: FileCoverage = JSON.parse(fileCoverageDataText);

        if (fileCoverageData && fileCoverageData.lineBlocksCoverage) {
            fileCoverageData.lineBlocksCoverage.forEach(function (coverageBlock: any, index: number) {
                const linesCount = coverageBlock.End - coverageBlock.Start + 1;

                if(linesCount > 0){
                    const coverageStatus: CoverageStatus = coverageBlock.Status;
                    let indicatorType = IndicatorType.Succeeded;
                    let toolTipHelpText = Resources.CoveredLinesHelpText;

                    if (coverageStatus == CoverageStatus.NotCovered) {
                        indicatorType = IndicatorType.Error;
                        toolTipHelpText = Resources.NotCoveredLinesHelpText;
                    }
                    else if(coverageStatus == CoverageStatus.PartiallyCovered)
                    {
                        indicatorType = IndicatorType.Warning;
                        toolTipHelpText = Resources.PartiallyCoveredLinesHelpText;
                    }

                    const gutterBlock: IGutterAdornmentBlock = {
                        LineNumberStart: coverageBlock.Start,
                        LinesCount: linesCount,
                        IndicatorType: indicatorType,
                        HelpText: toolTipHelpText,
                    };

                    if(isNewFile) {
                        gutterAdornmentCollection.originalFilegutterAdornments.push(gutterBlock);
                    } else {
                        gutterAdornmentCollection.modifiedFilegutterAdornments.push(gutterBlock);
                    }
                }
            });
        }

        return Promise.resolve(gutterAdornmentCollection);
    }
}

export let CodeCoveragePrAdornmentServiceName = "codecoverage-pr-adornment-service";

Services.add(CodeCoveragePrAdornmentServiceName, { serviceFactory: CodeCoveragePrAdornmentService });
